const getDisplayName = ({ displayName, name }) => displayName || name || 'Component';

export default getDisplayName;
